/* ===== 00-core.js ===== */
/* ==========================================================================
   SDOM3 — 00 core. Tiny module runner + helpers. ES2017, no optional chaining
   (Instagram in-app browser on older Android). Modules: sdom3.register(name, fn)
   where fn(root) must no-op when its markup is absent.
   ========================================================================== */
(function () {
  'use strict';
  if (window.sdom3) return;

  var modules = [];
  var booted = false;
  var sdom3 = {
    qs: function (sel, root) { return (root || document).querySelector(sel); },
    qsa: function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); },
    on: function (el, evt, selector, fn, opts) {
      if (typeof selector === 'function') { opts = fn; fn = selector; selector = null; }
      el.addEventListener(evt, function (e) {
        if (!selector) { fn.call(el, e, el); return; }
        var t = e.target && e.target.closest ? e.target.closest(selector) : null;
        if (t && el.contains(t)) fn.call(t, e, t);
      }, opts || false);
    },
    emit: function (name, detail, el) {
      (el || document).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    },
    register: function (name, fn) {
      modules.push({ name: name, fn: fn });
      if (booted) { try { fn(document); } catch (err) { if (window.console) console.warn('sdom3:' + name, err); } }
    },
    run: function (root) {
      root = root || document;
      modules.forEach(function (m) {
        try { m.fn(root); } catch (err) { if (window.console) console.warn('sdom3:' + m.name, err); }
      });
    },
    rerender: function (root) { sdom3.run(root); sdom3.emit('sdom3:rerender', { root: root }); },
    money: function (cents) { return '₪' + Math.round((Number(cents) || 0) / 100); },
    fetchSection: function (url, sectionId) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return fetch(u.toString(), { headers: { 'Accept': 'text/html' } }).then(function (r) {
        if (!r.ok) throw new Error('section fetch ' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc;
      });
    },
    lockScroll: function (lock) {
      document.documentElement.classList.toggle('sdom3-scroll-locked', !!lock);
    },
    openSheet: function (el) {
      if (!el) return;
      if (el.tagName === 'DIALOG' && typeof el.showModal === 'function') {
        if (!el.open) el.showModal();
      } else {
        el.classList.add('is-open');
        var scrim = sdom3.qs('.sdom3-scrim[data-for="' + el.id + '"]');
        if (scrim) scrim.classList.add('is-open');
      }
      el.setAttribute('aria-hidden', 'false');
      sdom3.lockScroll(true);
      var focusable = el.querySelector('[data-sdom3-close], [autofocus], button, [href], input, select, textarea');
      if (focusable) { try { focusable.focus(); } catch (e0) {} setTimeout(function () { focusable.focus(); }, 50); setTimeout(function () { if (document.activeElement === document.body) focusable.focus(); }, 230); }
      sdom3.emit('sdom3:sheet:open', { id: el.id }, el);
    },
    closeSheet: function (el) {
      if (!el) return;
      if (el.tagName === 'DIALOG' && typeof el.close === 'function') {
        if (el.open) el.close();
      } else {
        el.classList.remove('is-open');
        var scrim = sdom3.qs('.sdom3-scrim[data-for="' + el.id + '"]');
        if (scrim) scrim.classList.remove('is-open');
      }
      el.setAttribute('aria-hidden', 'true');
      if (!sdom3.qs('.sdom3-sheet.is-open, dialog.sdom3-sheet[open]')) sdom3.lockScroll(false);
      sdom3.emit('sdom3:sheet:close', { id: el.id }, el);
    },
    debounce: function (fn, ms) {
      var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms || 150); };
    },
    isTouch: function () { return window.matchMedia && window.matchMedia('(hover: none)').matches; },
    isDesktop: function () { return window.matchMedia && window.matchMedia('(min-width: 1000px)').matches; }
  };

  // Generic sheet wiring: [data-sdom3-open="#id"] opens, [data-sdom3-close] inside closes, Escape closes, scrim closes.
  sdom3.register('sheets', function (root) {
    if (root !== document) return;
    sdom3.on(document, 'click', '[data-sdom3-open]', function (e, t) {
      var target = sdom3.qs(t.getAttribute('data-sdom3-open'));
      if (!target) return;
      e.preventDefault();
      sdom3.openSheet(target);
    });
    sdom3.on(document, 'click', '[data-sdom3-close]', function (e, t) {
      var sheet = t.closest('.sdom3-sheet, dialog');
      if (sheet) { e.preventDefault(); sdom3.closeSheet(sheet); }
    });
    sdom3.on(document, 'click', '.sdom3-scrim.is-open', function (e, t) {
      var sheet = sdom3.qs('#' + t.getAttribute('data-for'));
      if (sheet) sdom3.closeSheet(sheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = sdom3.qs('.sdom3-sheet.is-open');
      if (open) sdom3.closeSheet(open);
    });
    // native <dialog> close (Escape / backdrop) → keep aria + scroll lock in sync
    sdom3.qsa('dialog.sdom3-sheet').forEach(function (d) {
      d.addEventListener('close', function () { d.setAttribute('aria-hidden', 'true'); if (!sdom3.qs('.sdom3-sheet.is-open, dialog.sdom3-sheet[open]')) sdom3.lockScroll(false); sdom3.emit('sdom3:sheet:close', { id: d.id }, d); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });
  });

  window.sdom3 = sdom3;

  function boot() { if (booted) return; booted = true; sdom3.run(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else setTimeout(boot, 0); /* let the remaining concatenated modules register first */
  document.addEventListener('shopify:section:load', function (e) { sdom3.run(e.target || document); });
})();

/* ===== 10-chrome.js ===== */
/* ==========================================================================
   SDOM3 — 10 chrome. Header cart count visibility + chip row positioning.
   ES2017, no optional chaining. Every module no-ops without its markup.
   ========================================================================== */
(function () {
  'use strict';
  var sdom3 = window.sdom3;
  if (!sdom3) return;

  var COUNT_SEL = 'cart-count.sdom3-header__count';

  /* Hide the bag digit (and the desktop "( )" wrapper) while the cart is empty.
     Focal's <cart-count> element writes item_count into itself on cart:updated / cart:refresh;
     we only mirror that into .is-empty. A MutationObserver covers any other writer. */
  function syncCount(el) {
    var n = parseInt(String(el.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
    var empty = n === 0;
    el.classList.toggle('is-empty', empty);
    var wrap = el.closest ? el.closest('.sdom3-header__count-wrap') : null;
    if (wrap) wrap.classList.toggle('is-empty', empty);
  }

  sdom3.register('cart-count', function (root) {
    var counts = sdom3.qsa(COUNT_SEL, root);
    if (!counts.length) return;

    counts.forEach(function (el) {
      syncCount(el);
      if (el.hasAttribute('data-sdom3-bound')) return;
      el.setAttribute('data-sdom3-bound', '');
      if (window.MutationObserver) {
        new MutationObserver(function () { syncCount(el); })
          .observe(el, { childList: true, characterData: true, subtree: true });
      }
    });

    if (document.documentElement.hasAttribute('data-sdom3-cart-count-bound')) return;
    document.documentElement.setAttribute('data-sdom3-cart-count-bound', '');

    var onCart = function (e) {
      var cart = e && e.detail ? e.detail.cart : null;
      var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      // run after Focal's own listener has written the new count
      setTimeout(function () {
        sdom3.qsa(COUNT_SEL).forEach(function (el) {
          if (n !== null && String(el.textContent || '').trim() !== String(n)) el.textContent = String(n);
          syncCount(el);
        });
      }, 0);
    };
    document.documentElement.addEventListener('cart:updated', onCart);
    document.documentElement.addEventListener('cart:refresh', onCart);
  });

  /* Chip row: bring the current collection's chip into view on load.
     Horizontal scroll of the row only — never scrollIntoView (it would scroll the page). */
  sdom3.register('chips', function (root) {
    sdom3.qsa('.sdom3-chips__row', root).forEach(function (row) {
      var cur = row.querySelector('.sdom3-chip[aria-current]');
      if (!cur) return;
      var rowRect = row.getBoundingClientRect();
      var curRect = cur.getBoundingClientRect();
      var offset = curRect.left - rowRect.left + row.scrollLeft;
      var target = offset - (row.clientWidth - curRect.width) / 2;
      var max = row.scrollWidth - row.clientWidth;
      if (max <= 0) return;
      row.scrollLeft = Math.max(0, Math.min(target, max));
    });
  });
})();

/* Cart errors: Shopify's 422 description arrives in the primary locale (Hebrew). Capture-phase, before
   CartNotification._onShow reads the same mutable detail object, swap it for English copy. */
(function () {
  'use strict';
  if (!window.sdom3 || document.documentElement.hasAttribute('data-sdom3-cart-error-bound')) return;
  document.documentElement.setAttribute('data-sdom3-cart-error-bound', '');
  document.addEventListener('cart-notification:show', function (e) {
    var d = e && e.detail;
    if (!d || d.status !== 'error') return;
    var msg = d.error || '';
    if (!msg || /[\u0590-\u05FF]/.test(msg)) {
      d.error = /\d/.test(msg) || /כמות|מלאי|נמצאת/.test(msg)
        ? "That's all we have in this size, and it's already in your bag."
        : 'Something went wrong. Please try again.';
    }
  }, true);
})();

/* ===== 20-cards.js ===== */
/* ==========================================================================
   SDOM3 — 20 cards. Line-dot active state for the two-image strip on touch devices.
   Passive scroll listener per strip, rAF-throttled; safe to re-run on any root
   (DOMContentLoaded, shopify:section:load, sdom3:rerender after load-more / facets).
   No-ops when no [data-sdom3-strip] is present. ES2017, no optional chaining.
   ========================================================================== */
sdom3.register('cards', function (root) {
  var strips = sdom3.qsa('.sdom3-card__strip[data-sdom3-strip]', root);
  if (!strips.length) return;

  strips.forEach(function (strip) {
    if (strip.__sdom3Dots) return;
    var card = strip.closest('.sdom3-card');
    if (!card) return;
    var dots = sdom3.qsa('.sdom3-card__dot', card);
    if (!dots.length) return;
    strip.__sdom3Dots = true;

    var ticking = false;
    var update = function () {
      ticking = false;
      var w = strip.clientWidth || 1;
      var i = Math.round(strip.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    };
    strip.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(update); else setTimeout(update, 16);
    }, { passive: true });
    /* initial state: a bfcache restore or a re-rendered grid may already be scrolled to the second image */
    update();
  });
});

/* ===== 21-home.js ===== */
/* ==========================================================================
   SDOM3 — 21 home. (1) promo tap-to-copy, (2) desktop-only campaign video.
   ES2017, no optional chaining (Instagram in-app browser on older Android).
   ========================================================================== */

/* (1) [data-sdom3-copy="CODE"] → clipboard; "Copy" → "Copied ✓" for 1.2s.
   Fallback: select the visible code text (and execCommand('copy') where it exists)
   so the user can copy by hand when the Clipboard API is unavailable (http, IG webview). */
sdom3.register('promo-copy', function (root) {
  if (root !== document) return; /* document-level delegation, bound once */

  var COPIED = 'Copied ✓';
  var SELECTED = 'Selected';

  function selectCode(codeEl) {
    if (!codeEl || !window.getSelection || !document.createRange) return false;
    try {
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      return true;
    } catch (err) { return false; }
  }

  function legacyCopy(code, codeEl) {
    var ok = false;
    var selected = selectCode(codeEl);
    if (!selected) {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { ok = document.execCommand && document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(ta);
      return ok ? 'copied' : 'failed';
    }
    try { ok = document.execCommand && document.execCommand('copy'); } catch (err) { ok = false; }
    if (ok) {
      try { window.getSelection().removeAllRanges(); } catch (err2) { /* noop */ }
      return 'copied';
    }
    return 'selected'; /* text stays selected for a manual copy */
  }

  function feedback(btn, state, code) {
    var label = btn.querySelector('[data-sdom3-copy-label]') || btn;
    var status = btn.parentNode ? btn.parentNode.querySelector('[data-sdom3-copy-status]') : null;
    if (!label.getAttribute('data-sdom3-copy-original')) label.setAttribute('data-sdom3-copy-original', label.textContent);
    var original = label.getAttribute('data-sdom3-copy-original');
    if (state === 'copied') {
      label.textContent = COPIED;
      btn.classList.add('is-copied');
      if (status) status.textContent = 'Code ' + code + ' copied';
    } else if (state === 'selected') {
      label.textContent = SELECTED;
      if (status) status.textContent = 'Code ' + code + ' selected, copy it';
    } else {
      return;
    }
    clearTimeout(btn.__sdom3CopyTimer);
    btn.__sdom3CopyTimer = setTimeout(function () {
      label.textContent = original;
      btn.classList.remove('is-copied');
    }, 1200);
  }

  sdom3.on(document, 'click', '[data-sdom3-copy]', function (e, btn) {
    e.preventDefault();
    var code = btn.getAttribute('data-sdom3-copy') || '';
    if (!code) return;
    var scope = btn.closest('.sdom3-promo') || document;
    var codeEl = scope.querySelector('[data-sdom3-code]');

    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(function () {
        feedback(btn, 'copied', code);
      }, function () {
        feedback(btn, legacyCopy(code, codeEl), code);
      });
    } else {
      feedback(btn, legacyCopy(code, codeEl), code);
    }
  });
});

/* (2) <video data-sdom3-desktop-video preload="none"> in the campaign tile:
   play muted + looping only on >= 1000px and only without prefers-reduced-motion;
   pause when the viewport drops below desktop. Mobile never downloads the file. */
sdom3.register('campaign-video', function (root) {
  var videos = sdom3.qsa('video[data-sdom3-desktop-video]', root);
  if (!videos.length) return;
  var mm = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  videos.forEach(function (v) {
    if (v.__sdom3Video) return;
    v.__sdom3Video = true;

    var sync = function () {
      var desktop = mm ? mm.matches : false;
      var reduced = reduce ? reduce.matches : false;
      if (desktop && !reduced) {
        v.muted = true;
        v.setAttribute('muted', '');
        try {
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* autoplay refused → poster stays */ });
        } catch (err) { /* noop */ }
      } else if (!v.paused) {
        try { v.pause(); } catch (err2) { /* noop */ }
      }
    };

    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    sync();
    if (mm) {
      if (mm.addEventListener) mm.addEventListener('change', sync);
      else if (mm.addListener) mm.addListener(sync);
    }
    if (reduce) {
      if (reduce.addEventListener) reduce.addEventListener('change', sync);
      else if (reduce.addListener) reduce.addListener(sync);
    }
  });
});

/* NEW IN swipe row: desktop arrow buttons scroll the row by ~one view */
(function () {
  'use strict';
  if (!window.sdom3) return;
  sdom3.register('home-scroller', function (root) {
    if (root !== document) return;
    sdom3.on(document, 'click', '[data-sdom3-scroll]', function (e, btn) {
      var row = btn.closest('.sdom3-row');
      var track = row ? row.querySelector('[data-sdom3-scroller]') : null;
      if (!track) return;
      var dir = parseInt(btn.getAttribute('data-sdom3-scroll'), 10) || 1;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
})();

/* ===== 30-collection.js ===== */
/* ==========================================================================
   SDOM3 — 30 collection (Area C). ES2017, no optional chaining / nullish coalescing.
   Works with Focal's ProductFacet (assets/theme.js):
     · it listens for `facet:criteria-changed` (detail: { url }) on <product-facet>, does
       history.replaceState(url), fetches ?section_id=… and swaps #facet-main / #facet-filters innerHTML;
     · <facet-filters> builds that URL from form#facet-filters-form on `change` of [name^="filter."].
   Modules (each no-ops without its markup):
     collection-load-more  — [data-sdom3-load-more] appends the next page into [data-sdom3-grid]
     collection-facets     — availability-aware size chips, Back/Forward support, sort <select> outside
                             Focal's handler, live status + desktop head count
   ========================================================================== */
(function () {
  'use strict';
  if (!window.sdom3) return;

  var FACET_EVENT = 'facet:criteria-changed';
  var SIZE_PARAM = 'filter.v.option.size';
  var STOCK_PARAM = 'filter.v.availability';
  var fromHistory = false;
  var lastUrl = null;

  function pathAndSearch(href) {
    try {
      var u = new URL(href || window.location.href, window.location.origin);
      return u.pathname + u.search;
    } catch (err) { return null; }
  }
  function facetOf(node) {
    return node && node.closest ? node.closest('product-facet') : null;
  }
  function dispatchFacet(facet, url) {
    facet.dispatchEvent(new CustomEvent(FACET_EVENT, { bubbles: true, detail: { url: url } }));
  }
  function setStatus(text) {
    var status = sdom3.qs('[data-sdom3-facet-status]');
    if (!status || !text) return;
    text = String(text).replace(/\s+/g, ' ').trim();
    if (text && status.textContent !== text) status.textContent = text;
  }
  // Parse markup in THIS document (like Focal's own innerHTML swap) so <product-item>, <quick-buy-popover>
  // and the customized built-ins (is="toggle-button" / "loader-button" / "product-form") upgrade reliably.
  function toLiveNodes(html) {
    var holder = document.createElement('div');
    holder.innerHTML = html;
    return Array.prototype.slice.call(holder.children);
  }
  // our grid on collection pages, Focal's .product-list__inner on the (untouched) search page
  var GRID_SEL = '[data-sdom3-grid], .product-list__inner';

  /* (1) LOAD MORE — fetch paginate.next.url (already carries the facet params) for this section,
         append the new cards, swap the button for the next page's, keep the address on page 1. */
  sdom3.register('collection-load-more', function (root) {
    if (root !== document) return;
    sdom3.on(document, 'click', '[data-sdom3-load-more]', function (e, btn) {
      var facet = facetOf(btn);
      var grid = facet ? facet.querySelector(GRID_SEL) : null;
      if (!facet || !grid || !window.fetch || !window.DOMParser || !window.URL) return; // stays a plain link
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var href = btn.getAttribute('href');
      var sectionId = facet.getAttribute('section-id');
      var originalHtml = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Loading…';

      sdom3.fetchSection(href, sectionId).then(function (doc) {
        var newGrid = doc.querySelector(GRID_SEL);
        if (!newGrid) throw new Error('sdom3: no grid in response');

        var nodes = toLiveNodes(newGrid.innerHTML);
        var first = nodes.length ? nodes[0] : null;
        var frag = document.createDocumentFragment();
        nodes.forEach(function (node) { frag.appendChild(node); });
        grid.appendChild(frag);

        var wrap = btn.closest('[data-sdom3-pagination]') || btn;
        var nextWrap = doc.querySelector('[data-sdom3-pagination]');
        var nextBtn = nextWrap ? nextWrap.querySelector('[data-sdom3-load-more]') : null;
        var total = btn.getAttribute('data-total');
        if (nextBtn && wrap.parentNode) {
          var liveWrap = toLiveNodes(nextWrap.outerHTML)[0];
          wrap.parentNode.replaceChild(liveWrap, wrap);
          setStatus('More products loaded');
        } else if (wrap.parentNode) {
          wrap.parentNode.removeChild(wrap);
          setStatus('All products shown');
        }

        // keyboard / screen-reader users land on the first new card
        if (first) {
          var target = (first.matches && first.matches('a, button')) ? first : first.querySelector('a, button');
          if (target) {
            try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
          }
        }

        sdom3.rerender(facet.closest('.shopify-section') || facet);
      }).catch(function () {
        // network / parse failure → behave like the plain link
        btn.removeAttribute('aria-busy');
        btn.innerHTML = originalHtml;
        window.location.href = href;
      });
    });
  });

  /* AVAILABILITY-AWARE SIZES — Shopify's filter.v.option.size matches a product when ANY variant has the size,
     sold out or not; only filter.v.availability in the SAME request narrows it to in-stock variants.
     withSizeStock(href) → URL with the availability value added when it has a size but no availability, else null. */
  function withSizeStock(href) {
    if (!window.URL) return null;
    try {
      var u = new URL(href || window.location.href, window.location.origin);
      if (!u.searchParams.getAll(SIZE_PARAM).length || u.searchParams.has(STOCK_PARAM)) return null;
      u.searchParams.append(STOCK_PARAM, '1');
      return u;
    } catch (err) { return null; }
  }

  // Runs in the CAPTURE phase of the chip's `change`, i.e. before Focal's FacetFilters (bubble phase on
  // <facet-filters>) serialises the form: ≥1 size checked → hidden availability input present and the
  // "In stock" chip shown checked + locked; no size → hidden input gone, "In stock" back to what the
  // shopper chose before picking a size (remembered on <product-facet>, which Focal never swaps).
  function syncSizeStock(form, facet, target) {
    var sizes = form.querySelectorAll('input[name="' + SIZE_PARAM + '"]');
    if (!sizes.length) return;
    var stock = form.querySelector('input[type="checkbox"][name="' + STOCK_PARAM + '"]');
    if (stock && target === stock) { facet.sdom3KeepStock = stock.checked; return; }
    var anySize = false;
    for (var i = 0; i < sizes.length; i++) { if (sizes[i].checked) { anySize = true; break; } }
    var hidden = form.querySelector('input[data-sdom3-size-stock]');
    if (anySize) {
      if (stock && !stock.disabled && stock.checked) facet.sdom3KeepStock = true;
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = STOCK_PARAM;
        hidden.value = stock ? stock.value : '1';
        hidden.setAttribute('data-sdom3-size-stock', '');
        form.appendChild(hidden);
      }
    } else if (hidden && hidden.parentNode) {
      hidden.parentNode.removeChild(hidden);
    }
    if (stock) {
      stock.disabled = anySize;
      stock.checked = anySize || !!facet.sdom3KeepStock;
      var chip = stock.closest('.sdom3-qf__chip');
      if (chip) chip.classList.toggle('is-locked', anySize);
      var note = chip ? chip.querySelector('[data-sdom3-stock-note]') : null;
      if (note) note.hidden = !anySize;
    }
  }

  // Count + Clear are re-rendered inside #facet-main; mirror the count into the persistent status region and
  // the desktop head count (outside #facet-main). The empty state has no count element → "0 products".
  function mirrorCount() {
    var main = sdom3.qs('#facet-main');
    if (!main) return;
    var count = main.querySelector('[data-sdom3-count]');
    var text = count ? count.textContent : (main.querySelector('.sdom3-coll__empty') ? '0 products' : '');
    text = String(text).replace(/\s+/g, ' ').trim();
    if (!text) return;
    setStatus(text);
    sdom3.qsa('[data-sdom3-head-count]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  // Swap #facet-main / #facet-filters for `url` like ProductFacet._rerender does, minus its smooth
  // scrollIntoView (used once on load to normalise a size link that lacks availability).
  function silentRefresh(facet, url) {
    var main = facet.querySelector('#facet-main');
    var sectionId = facet.getAttribute('section-id');
    if (!main || !sectionId || !window.fetch || !window.DOMParser || !window.history || !history.replaceState) return;
    try { history.replaceState(history.state, '', url); } catch (err) { return; }
    lastUrl = pathAndSearch();
    main.setAttribute('aria-busy', 'true');
    sdom3.fetchSection(url, sectionId).then(function (doc) {
      var nextMain = doc.querySelector('#facet-main');
      if (!nextMain) throw new Error('sdom3: no #facet-main in response');
      main.innerHTML = nextMain.innerHTML;
      var filters = facet.querySelector('#facet-filters');
      var nextFilters = doc.querySelector('#facet-filters');
      if (filters && nextFilters) filters.innerHTML = nextFilters.innerHTML;
      main.removeAttribute('aria-busy');
      mirrorCount();
      sdom3.rerender(facet.closest('.shopify-section') || facet);
    }).catch(function () {
      main.removeAttribute('aria-busy');
      window.location.replace(url); // the address already carries availability → no loop
    });
  }

  /* (2)+(3)+(4)+(5) SIZE AVAILABILITY, FACET HISTORY, SORT SELECT, LIVE STATUS */
  sdom3.register('collection-facets', function (root) {
    if (root !== document) return;
    var firstFacet = sdom3.qs('product-facet');
    if (!firstFacet) return;
    lastUrl = pathAndSearch();
    try {
      var lu = new URL(window.location.href);
      if (!lu.searchParams.has(SIZE_PARAM)) firstFacet.sdom3KeepStock = lu.searchParams.has(STOCK_PARAM);
    } catch (err0) {}

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input[name="' + SIZE_PARAM + '"], input[name="' + STOCK_PARAM + '"]')) return;
      var form = t.form;
      var facet = facetOf(t);
      if (!form || !facet || form.id !== 'facet-filters-form') return;
      var strip = t.closest('.sdom3-qf--inputs, .sdom3-qf');
      facet.sdom3Restore = { scroll: strip ? strip.scrollLeft : 0, name: t.name, value: t.value, focused: document.activeElement === t };
      syncSizeStock(form, facet, t);
    }, true);

    // A size link without availability (old bookmark, shared URL, typed address) → show the in-stock result.
    var fixedNow = withSizeStock(window.location.href);
    if (fixedNow) silentRefresh(firstFacet, fixedNow.pathname + fixedNow.search + fixedNow.hash);

    // Focal calls history.replaceState(newUrl) inside ProductFacet._rerender. This capture-phase listener runs
    // first and pushes the CURRENT address as a new entry, so the entry Focal replaces is the new one and the
    // previous filter state stays behind it → Back returns to it. It also adds availability to any facet URL
    // that carries a size without it (sort change, Back to an old entry, a missed sync) — Focal reads
    // event.detail.url after us, so the fetch and the address both get it.
    document.addEventListener(FACET_EVENT, function (e) {
      if (e.detail && e.detail.url) {
        var fixed = withSizeStock(e.detail.url);
        if (fixed) {
          try { e.detail.url = fixed.pathname + fixed.search; } catch (err) {}
        }
      }
      if (e.detail && e.detail.url && window.URL) {
        try {
          var nu = new URL(e.detail.url, window.location.origin);
          var fct = facetOf(e.target) || sdom3.qs('product-facet');
          if (fct && !nu.searchParams.has(SIZE_PARAM)) fct.sdom3KeepStock = nu.searchParams.has(STOCK_PARAM);
        } catch (err2) {}
      }
      var next = e.detail && e.detail.url ? pathAndSearch(e.detail.url) : null;
      if (!fromHistory && next && next !== pathAndSearch() && window.history && history.pushState) {
        try { history.pushState({ sdom3Facet: true }, '', window.location.href); } catch (err) {}
      }
      fromHistory = false;
      if (next) lastUrl = next;
    }, true);

    // Back / Forward: re-dispatch Focal's event with the address we are now on (replaceState becomes a no-op).
    window.addEventListener('popstate', function () {
      var now = pathAndSearch();
      if (!now || now === lastUrl) return; // hash-only or unrelated state change
      var facet = sdom3.qs('product-facet');
      if (!facet) return;
      lastUrl = now;
      fromHistory = true;
      dispatchFacet(facet, window.location.href);
    });

    // Sort <select name="sort_by"> lives in the facets form but is not a filter.* input, so Focal ignores it.
    sdom3.on(document, 'change', 'product-facet select[name="sort_by"]', function (e, select) {
      var facet = facetOf(select);
      if (!facet || !window.URL) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', select.value);
      u.searchParams.delete('page');
      dispatchFacet(facet, u.toString());
    });

    // Focal signals the swap is done with theme:loading:end (bubbles from <html>).
    if (sdom3.qs('[data-sdom3-facet-status], [data-sdom3-head-count]')) {
      document.addEventListener('theme:loading:end', mirrorCount);
    }
    document.addEventListener('theme:loading:end', function () {
      var facet = sdom3.qs('product-facet');
      var r = facet && facet.sdom3Restore;
      if (!r) return;
      facet.sdom3Restore = null;
      var strip = facet.querySelector('.sdom3-qf--inputs, .sdom3-qf');
      if (strip) strip.scrollLeft = r.scroll;
      var input = null;
      sdom3.qsa('input[name="' + r.name + '"]', facet).some(function (el) { if (el.value === r.value) { input = el; return true; } return false; });
      if (input) {
        var chip = input.closest('label') || input;
        try { chip.scrollIntoView({ inline: 'nearest', block: 'nearest' }); } catch (e3) {}
        if (r.focused) { try { input.focus({ preventScroll: true }); } catch (e4) { input.focus(); } }
      }
    });
  });

  /* SEARCH PAGE GUARD — Focal's <search-page> caches #mobile-facet-toolbar at connect time and toggles a class
     on it whenever the results tab changes. The layout no longer renders that toolbar, so give the instance a
     detached stand-in instead of letting the tab switch throw. theme.js runs before this file (both deferred). */
  sdom3.register('search-skin', function (root) {
    if (root !== document) return;
    try {
      var su = new URL(window.location.href);
      if (su.pathname.replace(/\/$/, '').slice(-7) === '/search' && su.searchParams.get('q') && !su.searchParams.get('type')) {
        su.searchParams.set('type', 'product');
        window.location.replace(su.toString());
        return;
      }
    } catch (e5) {}
    sdom3.qsa('search-page').forEach(function (sp) {
      if (!sp.facetToolbar) sp.facetToolbar = document.createElement('div');
    });
  });
})();

/* ===== 40-pdp.js ===== */
/* ==========================================================================
   SDOM3 — 40 pdp (Area D). ES2017, no optional chaining / nullish coalescing.
   Works with Focal's theme.js on the product form:
     · ProductVariants (<product-variants form-id>) listens to `change` on [name^="option"], writes the
       hidden input[name="id"] and dispatches `variant:changed` {variant} on the <form>;
     · PaymentContainer / ProductMeta / ProductInventory / ProductStickyForm react to `variant:changed`;
     · ProductForm (form[is="product-form"]) posts /cart/add.js on submit and dispatches `variant:added`.
   Modules (each no-ops without its markup):
     pdp-gate            no size preselected: blanks the id, "Select a size" label, capture-phase submit block,
                         pill availability, notify slot, sticky chip label, "Added" feedback
     pdp-size-sheet      sticky bar SIZE chip → bottom sheet with a clone of the pill row, synced to the main form
     pdp-overlays        body.sdom3-overlay-open while any sheet / Focal drawer / popover is open (hides the bar)
     pdp-gallery-counter mono "n/m" next to the gallery dots from Focal's flickity:slide-changed
   ========================================================================== */
(function () {
  'use strict';
  var sdom3 = window.sdom3;
  if (!sdom3) return;

  var UNSEL = 'sdom-unselected';
  var html = document.documentElement;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function fid(form) { return (form && form.getAttribute) ? (form.getAttribute('id') || '') : ''; } // never form.id: the <input name=id> shadows it
  function rootOf(form) {
    return form.closest('.product-form') || form.parentNode || document;
  }
  function parseVariants(form) {
    var script = document.querySelector('script[data-sdom3-variants="' + fid(form) + '"]');
    if (!script) return [];
    try { var v = JSON.parse(script.textContent); return Array.isArray(v) ? v : []; } catch (err) { return []; }
  }
  function optionInputs(form) {
    // radios / selects are form-associated through form="…" and live outside the <form> element
    return Array.prototype.slice.call(form.elements || []).filter(function (el) {
      return /^option\d$/.test(el.name || '') && (el.type === 'radio' || el.tagName === 'SELECT');
    });
  }
  function selectedValues(form) {
    var values = [];
    optionInputs(form).forEach(function (el) {
      var idx = parseInt(el.name.replace('option', ''), 10) - 1;
      if (idx < 0) return;
      if (el.tagName === 'SELECT') values[idx] = el.value;
      else if (el.checked) values[idx] = el.value;
    });
    return values;
  }
  function findVariant(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      var match = opts.length > 0;
      for (var k = 0; k < opts.length; k++) { if (opts[k] !== values[k]) { match = false; break; } }
      if (match) return variants[i];
    }
    return null;
  }
  function valueAvailable(variants, index, value) {
    return variants.some(function (v) { return v.available && v.options && v.options[index] === value; });
  }
  function setButtonText(btn, text) {
    if (!btn) return;
    var t = btn.querySelector('.loader-button__text');
    if (t) t.textContent = text; else btn.textContent = text;
  }
  function labelOf(btn, attr, fallback) {
    return (btn && btn.getAttribute(attr)) || fallback;
  }

  /* ----- gate state per form ----- */
  function setAtc(st, mode, variant) {
    var btn = st.atc;
    if (!btn) return;
    var label;
    if (mode === 'select') {
      label = labelOf(btn, 'data-label-select', 'Select a size');
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-unselected');
    } else if (mode === 'soldout') {
      label = labelOf(btn, 'data-label-sold-out', 'Sold out');
      btn.setAttribute('disabled', 'disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-unselected');
    } else {
      label = labelOf(btn, 'data-label-add', labelOf(btn, 'data-button-content', 'Add to cart'));
      if (btn.hasAttribute('data-sdom3-price-in-atc') && variant && typeof variant.price === 'number') {
        label += ' — ' + sdom3.money(variant.price);
      }
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-unselected');
    }
    setButtonText(btn, label);
  }

  function syncPills(st) {
    var selectors = sdom3.qsa('.product-form__option-selector', st.root);
    selectors.forEach(function (sel, index) {
      sdom3.qsa('[data-sdom3-pill]', sel).forEach(function (label) {
        var input = document.getElementById(label.getAttribute('for') || '');
        var value = label.getAttribute('data-value');
        if (value === null) value = label.textContent.trim();
        if (st.variants.length) label.classList.toggle('is-unavailable', !valueAvailable(st.variants, index, value));
        label.classList.toggle('is-selected', !!(input && input.checked));
      });
    });
  }

  function updateNotify(st, variant) {
    var slot = sdom3.qs('[data-sdom3-notify]', st.root);
    if (!slot) return;
    var show = st.soldOut || !!(variant && !variant.available);
    slot.hidden = !show;
    var note = slot.querySelector('[data-sdom3-notify-note]');
    var link = slot.querySelector('[data-sdom3-notify-link]');
    var sizeText = variant && !variant.available ? variant.title : '';
    if (note) {
      if (sizeText) { note.textContent = 'Size ' + sizeText + ' is sold out.'; note.hidden = false; }
      else { note.textContent = ''; note.hidden = true; }
    }
    if (link) {
      var base = link.getAttribute('data-href-base') || link.getAttribute('href') || '';
      link.setAttribute('href', sizeText ? base + encodeURIComponent(' in size ' + sizeText) : base);
    }
  }

  function syncSticky(st, variant) {
    sdom3.qsa('[data-sdom3-sticky][data-sdom3-form="' + fid(st.form) + '"] [data-sdom3-size-chip-label]').forEach(function (el) {
      el.textContent = variant ? 'Size · ' + variant.title : 'Size';
    });
    sdom3.qsa('[data-sdom3-size-sheet][data-sdom3-form="' + fid(st.form) + '"] [data-sdom3-sheet-size]').forEach(function (b) {
      var on = !!(variant && variant.options && variant.options.indexOf(b.getAttribute('data-sdom3-sheet-size')) !== -1);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function triggerVariantChanged(st, variant) {
    st.form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
  }

  function openGate(st, variant, fromOption) {
    st.open = true;
    st.form.classList.remove(UNSEL);
    st.root.classList.remove(UNSEL);
    if (variant) {
      st.selected = variant;
      if (st.idInput && String(st.idInput.value) !== String(variant.id)) {
        st.idInput.value = variant.id;
        // Focal did not get here (its listener was not bound yet, or it early-returned): notify its components.
        if (fromOption) triggerVariantChanged(st, variant);
      }
      setAtc(st, variant.available ? 'add' : 'soldout', variant);
    } else {
      setAtc(st, st.soldOut ? 'soldout' : 'select');
    }
    syncPills(st);
    updateNotify(st, variant);
    syncSticky(st, variant);
    sdom3.emit('sdom3:variant', { formId: fid(st.form), variant: variant }, st.form);
  }

  function onOptionChange(st, input) {
    var values = selectedValues(st.form);
    var variant = findVariant(st.variants, values);
    if (!variant && st.variants.length === 1) variant = st.variants[0];
    openGate(st, variant, true);
    var span = input && input.getAttribute('data-bind-value') ? document.getElementById(input.getAttribute('data-bind-value')) : null;
    if (span && !span.textContent) span.textContent = input.value;
  }

  function blankWhenFocalReady(st) {
    // The server renders the unselected state (blank hidden id). Focal's ProductVariants reads
    // `this.selectedVariant["id"]` once its product.js fetch resolves (it would throw on a blank id), then
    // early-returns when that id is already selected. So: prime the id with a real variant until Focal has
    // initialised (`pv.product` set), then blank it again. Poll ≤10 s (slow in-app webviews), then blank anyway.
    // The primer is the first AVAILABLE variant: Focal's selectVariant() then early-returns; an unavailable primer
    // with hide-sold-out-variants would make Focal pick (and check) another size, i.e. preselect one.
    // (If Focal's fetch beat sdom3.js it already threw after binding its listeners, which is harmless.)
    var pv = st.pv, tries = 0;
    var blank = function () { if (!st.open && st.idInput) st.idInput.value = ''; };
    if (!pv) { blank(); return; }
    if (st.idInput && st.idInput.value === '' && st.variants.length && !pv.product) {
      var primer = st.variants[0];
      for (var i = 0; i < st.variants.length; i++) { if (st.variants[i].available) { primer = st.variants[i]; break; } }
      st.idInput.value = primer.id;
    }
    (function poll() {
      if (st.open) return;
      if (pv.product || tries > 200) { blank(); return; }
      tries++;
      setTimeout(poll, 50);
    })();
  }

  function nudgePills(st) {
    var row = sdom3.qs('[data-sdom3-pill-row]', st.root) || sdom3.qs('.sdom3-pill-row', st.root);
    if (!row) return;
    try { row.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' }); } catch (err) { row.scrollIntoView(); }
    row.classList.remove('is-pulsing');
    void row.offsetWidth;
    row.classList.add('is-pulsing');
    setTimeout(function () { row.classList.remove('is-pulsing'); }, 600);
    var first = null;
    sdom3.qsa('[data-sdom3-pill]', row).some(function (label) {
      if (label.classList.contains('is-unavailable')) return false;
      first = document.getElementById(label.getAttribute('for') || '');
      return !!first;
    });
    if (first) { try { first.focus({ preventScroll: true }); } catch (err) { /* older WebKit */ } }
  }

  function initGate(form) {
    if (!form || form.__sdom3Gate) return;
    var root = rootOf(form);
    var variants = parseVariants(form);
    var st = {
      form: form,
      root: root,
      variants: variants,
      idInput: form.querySelector('input[name="id"]'),
      atc: form.querySelector('[data-product-add-to-cart-button]'),
      pv: root.querySelector ? root.querySelector('product-variants') : null,
      soldOut: root.hasAttribute('data-sdom3-sold-out') || (variants.length > 0 && !variants.some(function (v) { return v.available; })),
      open: false,
      selected: null
    };
    form.__sdom3Gate = st;

    var inputs = optionInputs(form);
    var preselected = root.hasAttribute('data-sdom3-preselected');

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !/^option\d$/.test(t.name || '')) return;
      onOptionChange(st, t);
    });
    form.addEventListener('variant:changed', function (e) {
      var v = e.detail ? e.detail.variant : null;
      if (v) openGate(st, v, false);
    });
    form.addEventListener('variant:added', function () {
      if (!st.atc) return;
      setButtonText(st.atc, 'Added ✓');
      setTimeout(function () { if (st.open) setAtc(st, st.selected && !st.selected.available ? 'soldout' : 'add', st.selected); }, 600);
    });

    syncPills(st);

    if (!inputs.length || preselected) {
      // single-variant product, or an explicit ?variant= link: nothing to gate
      st.open = true;
      var current = findVariant(variants, selectedValues(form)) || (variants.length === 1 ? variants[0] : null);
      st.selected = current;
      if (st.soldOut) setAtc(st, 'soldout');
      else if (current && st.atc && st.atc.hasAttribute('data-sdom3-price-in-atc')) setAtc(st, current.available ? 'add' : 'soldout', current);
      updateNotify(st, current);
      syncSticky(st, current);
      return;
    }

    form.classList.add(UNSEL);
    root.classList.add(UNSEL);
    inputs.forEach(function (el) { if (el.type === 'radio') el.checked = false; });
    sdom3.qsa('[data-sdom3-option-value]', root).forEach(function (span) { span.textContent = ''; });
    syncPills(st);
    setAtc(st, st.soldOut ? 'soldout' : 'select');
    updateNotify(st, null);
    syncSticky(st, null);
    blankWhenFocalReady(st);
  }

  function bindGlobalGate() {
    if (html.hasAttribute('data-sdom3-gate-bound')) return;
    html.setAttribute('data-sdom3-gate-bound', '');

    // Capture phase: runs before Focal's LoaderButton / ProductForm and before Klaviyo's click tracker.
    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('button[type="submit"], [data-product-add-to-cart-button]') : null;
      if (!target) return;
      var form = target.form || (target.getAttribute('form') ? document.getElementById(target.getAttribute('form')) : target.closest('form'));
      if (!form || !form.hasAttribute('data-sdom3-gate')) return;
      var st = form.__sdom3Gate;
      if (!st || st.open) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (st.soldOut) return;
      var sheet = target.hasAttribute('data-sdom3-sticky-submit') ? sdom3.qs('[data-sdom3-size-sheet][data-sdom3-form="' + fid(form) + '"]') : null;
      if (sheet) sdom3.openSheet(sheet); else nudgePills(st);
    }, true);

    // Belt and braces: a programmatic submit while unselected is dropped too.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-sdom3-gate')) return;
      var st = form.__sdom3Gate;
      if (st && !st.open) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    // Quick-buy popovers / drawers inject a product form later: pick it up.
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function (muts) {
        var added = false;
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { added = true; break; } }
        if (!added || pending) return;
        pending = true;
        setTimeout(function () { pending = false; sdom3.qsa('form[data-sdom3-gate]').forEach(initGate); }, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  sdom3.register('pdp-gate', function (root) {
    sdom3.qsa('form[data-sdom3-gate]', root).forEach(initGate);
    if (root === document) bindGlobalGate();
  });

  /* ----- sticky bar size sheet: clone of the pill row, synced to the main form ----- */
  sdom3.register('pdp-size-sheet', function (root) {
    sdom3.qsa('[data-sdom3-size-sheet]', root).forEach(function (sheet) {
      if (sheet.__sdom3Sheet) return;
      var formId = sheet.getAttribute('data-sdom3-form');
      var form = document.getElementById(formId || '');
      var host = sheet.querySelector('[data-sdom3-size-sheet-pills]');
      if (!form || !host) return;
      sheet.__sdom3Sheet = true;
      var chip = sdom3.qs('[data-sdom3-sticky][data-sdom3-form="' + formId + '"] [data-sdom3-size-chip]');

      var build = function () {
        var st = form.__sdom3Gate;
        var formRoot = st ? st.root : rootOf(form);
        var pills = sdom3.qsa('[data-sdom3-pill-row] [data-sdom3-pill]', formRoot);
        if (!pills.length) pills = sdom3.qsa('.sdom3-pill-row [data-sdom3-pill]', formRoot);
        host.innerHTML = '';
        pills.forEach(function (label) {
          var input = document.getElementById(label.getAttribute('for') || '');
          var value = label.getAttribute('data-value');
          if (value === null) value = label.textContent.trim();
          var unavailable = label.classList.contains('is-unavailable');
          var selected = !!(input && input.checked);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sdom3-pill' + (unavailable ? ' is-unavailable' : '') + (selected ? ' is-selected' : '');
          b.setAttribute('data-sdom3-sheet-size', value);
          b.setAttribute('aria-pressed', selected ? 'true' : 'false');
          b.textContent = value;
          if (unavailable) {
            var sr = document.createElement('span');
            sr.className = 'sdom3-visually-hidden';
            sr.textContent = ' (sold out)';
            b.appendChild(sr);
          }
          b.addEventListener('click', function () {
            if (input && !input.checked) input.click(); // fires change → Focal + gate
            sdom3.closeSheet(sheet);
          });
          host.appendChild(b);
        });
        var note = sheet.querySelector('[data-sdom3-size-sheet-note]');
        if (note) {
          var anyUnavailable = pills.some(function (l) { return l.classList.contains('is-unavailable'); });
          note.textContent = anyUnavailable ? 'Struck sizes are sold out — pick one to get notified when it is back.' : '';
          note.hidden = !anyUnavailable;
        }
      };

      build();
      sheet.addEventListener('sdom3:sheet:open', function () { build(); if (chip) chip.setAttribute('aria-expanded', 'true'); });
      sheet.addEventListener('sdom3:sheet:close', function () { if (!chip) return; chip.setAttribute('aria-expanded', 'false'); document.body.classList.remove('sdom3-overlay-open'); setTimeout(function () { try { chip.focus({ preventScroll: true }); } catch (e6) { chip.focus(); } }, 30); });
      form.addEventListener('sdom3:variant', build);
    });
  });

  /* ----- Klaviyo Back in Stock button: site label on the button Klaviyo injects (re-applied on every re-render) ----- */
  sdom3.register('klaviyo-bis', function (root) {
    if (root !== document) return;
    if (html.hasAttribute('data-sdom3-bis-bound')) return;
    html.setAttribute('data-sdom3-bis-bound', '');
    var label = function () {
      var n = sdom3.qs('[data-sdom3-notify]');
      return (n && n.getAttribute('data-bis-label')) || "Notify me when it's back";
    };
    var textNode = function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) { if (node.nodeValue.trim()) return node; }
      return null;
    };
    var busy = false;
    var apply = function () {
      if (busy) return;
      busy = true;
      sdom3.qsa('#klaviyo-bis-button-container button').forEach(function (b) {
        var want = label(), node = textNode(b);
        if (node && node.nodeValue !== want) node.nodeValue = want;
        if (b.getAttribute('aria-label') !== want) b.setAttribute('aria-label', want);
      });
      busy = false;
    };
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    apply();
  });

  /* ----- hide the sticky bar while any sheet / drawer / popover is open ----- */
  sdom3.register('pdp-overlays', function (root) {
    if (root !== document) return;
    if (html.hasAttribute('data-sdom3-overlays-bound')) return;
    html.setAttribute('data-sdom3-overlays-bound', '');
    // product-image-zoom[open] (Focal toggles it; PhotoSwipe only drops .pswp--open after its close animation,
    // so that class is never used here) — plus a second pass ~450 ms later for anything that settles after a transition.
    var SEL = '.sdom3-sheet.is-open, dialog.sdom3-sheet[open], drawer-content[open], popover-content[open], cart-drawer[open], ' +
              'quick-buy-drawer[open], quick-buy-popover[open], mobile-navigation[open], predictive-search-drawer[open], ' +
              'combo-box[open], .drawer[open], .popover[open], product-image-zoom[open]';
    var recompute = function () {
      var open = !!sdom3.qs(SEL) || html.classList.contains('lock-all') || html.classList.contains('lock-mobile') || html.classList.contains('sdom3-scroll-locked');
      document.body.classList.toggle('sdom3-overlay-open', open);
    };
    var later = function () { setTimeout(recompute, 0); setTimeout(recompute, 450); };
    ['sdom3:sheet:open', 'sdom3:sheet:close', 'openable-element:open', 'openable-element:close', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, later);
    });
    if (window.MutationObserver) {
      new MutationObserver(later).observe(html, { attributes: true, attributeFilter: ['class'] });
    }
    recompute();
  });

  /* ----- gallery counter "n/m" (mobile dots row) ----- */
  sdom3.register('pdp-gallery-counter', function (root) {
    sdom3.qsa('product-media', root).forEach(function (media) {
      if (media.__sdom3Counter) return;
      var carousel = media.querySelector('flickity-carousel');
      var dots = media.querySelector('.product__media-nav .dots-nav');
      if (!carousel || !dots) return;
      var items = function () { return sdom3.qsa('.product__media-item:not(.is-filtered)', carousel); };
      if (items().length < 2) return;
      media.__sdom3Counter = true;

      var counter = document.createElement('span');
      counter.className = 'sdom3-gallery__counter sdom3-mono sdom3-mono--sm';
      counter.setAttribute('aria-live', 'polite');
      dots.parentNode.insertBefore(counter, dots.nextSibling);

      var render = function () {
        var list = items(), index = 0;
        for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('is-selected')) { index = i; break; } }
        counter.textContent = (index + 1) + '/' + list.length;
      };
      carousel.addEventListener('flickity:ready', function () { setTimeout(render, 0); });
      carousel.addEventListener('flickity:slide-changed', function () { setTimeout(render, 0); });
      carousel.addEventListener('flickity:slide-settled', function () { setTimeout(render, 0); });
      render();
    });
  });
})();

/* ===== 50-cart.js ===== */
/* ==========================================================================
   SDOM3 — 50 cart. Keeps the drawer honest between Focal's `cart:updated` (instant, JSON) and its
   `cart:refresh` re-render (600–750 ms later): header count, free-shipping copy, and hiding the
   "Add to your order" block once the cart holds 3+ items. After Focal swaps the drawer's innerHTML
   (CartDrawer._rerenderCart) the sdom3 modules are re-run on the new content so the upsell cards
   (Area B `cards` module) initialise. No-ops without the markup. ES2017, no `?.`.
   ========================================================================== */
sdom3.register('cart', function (root) {
  if (root !== document) return;
  var html = document.documentElement;
  if (html.getAttribute('data-sdom3-cart-bound') === '1') return;
  html.setAttribute('data-sdom3-cart-bound', '1');

  function shekels(cents) { return '₪' + Math.ceil((Number(cents) || 0) / 100); }

  html.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || typeof cart.item_count !== 'number') return;

    sdom3.qsa('span[data-sdom3-cart-count], [data-sdom3-cart-count]:not(html):not(body)').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });

    if (cart.item_count >= 3) {
      sdom3.qsa('[data-sdom3-cart-recs]').forEach(function (el) { el.hidden = true; });
    }

    sdom3.qsa('free-shipping-bar[data-sdom3-ship]').forEach(function (bar) {
      var threshold = parseFloat(bar.getAttribute('threshold')) || 0;
      var text = bar.querySelector('[data-sdom3-ship-text]');
      if (!threshold || !text) return;
      var remaining = threshold - (Number(cart.total_price) || 0);
      var unlocked = remaining <= 0;
      text.textContent = unlocked ? 'Free shipping unlocked' : shekels(remaining) + ' more for free shipping';
      bar.classList.toggle('is-unlocked', unlocked);
    });
  });

  /* Focal replaces <cart-drawer>'s innerHTML on cart:refresh; re-run the module set on the drawer
     (direct children only, debounced) so cards / sheets inside the fresh markup are wired. */
  var drawer = sdom3.qs('#mini-cart');
  if (!drawer || !window.MutationObserver) return;
  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      sdom3.rerender(drawer);
      observer.takeRecords(); // drop mutations the modules themselves just made (no re-entry)
    }, 0);
  });
  observer.observe(drawer, { childList: true });
});
